var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonDanger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_user-square",
    "data-name": "vuesax/bulk/user-square",
    transform: "translate(-748 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(748 188)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M20,5.81v8.38c0,2.81-1.29,4.74-3.56,5.47a6.861,6.861,0,0,1-2.25.34H5.81a6.861,6.861,0,0,1-2.25-.34C1.29,18.93,0,17,0,14.19V5.81C0,2.17,2.17,0,5.81,0h8.38C17.83,0,20,2.17,20,5.81Z",
    transform: "translate(750 190)",
    fill: "#fd403f",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M12.88,4.69a6.861,6.861,0,0,1-2.25.34H2.25A6.861,6.861,0,0,1,0,4.69C.35,2.05,3.11,0,6.44,0S12.53,2.05,12.88,4.69Z",
    transform: "translate(753.56 204.97)",
    fill: "#fd403f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M7.16,3.58A3.58,3.58,0,1,1,3.58,0,3.585,3.585,0,0,1,7.16,3.58Z",
    transform: "translate(756.42 196)",
    fill: "#fd403f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonDanger);
export default __webpack_public_path__ + "static/media/person-danger.0084ee0d7896e2fbca9a59f593ce218c.svg";
export { ForwardRef as ReactComponent };